import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChPagerComponent } from './ch-pager.component';


export class ChPagerModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule
  ],
  exports: [ChPagerComponent],
  declarations: [ChPagerComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
